export default [
  {
    key: 'lembaga',
    icon: 'mdi-bank',
    title: 'Profil Lembaga',
    desc: 'Pengajuan dan Detail Profil LPD',
    color: 'yellow',
    deepColor: 'darken-1',
    akses: 'lpd-profil.index',
    link: 'profil-operator',
    to: { name: 'profil-operator' },
    submenu: false,
  },
  {
    key: 'kelola',
    program: 'Kelola Akun',
    subheading: 'Kelola Akun',
    submenu: false,
    icon: 'mdi-account-cog',
    menu: [
      {
        icon: 'mdi-office-building-outline',
        title: 'Kelola Institusi LPD',
        desc: 'Pengelolaan data Institusi LPD',
        color: 'red',
        deepColor: 'darken-4',
        akses: 'lpd.index',
        link: 'institusi',
        to: { name: 'institusi' },
      },
      {
        icon: 'mdi-account-tie',
        title: 'Kelola Admin Program LPD',
        desc: 'Pengelolaan data Akun Admin Program LPD',
        color: 'blue',
        deepColor: 'darken-4',
        akses: 'akun-admin-program-lpd.index',
        link: 'akun-program',
        to: { name: 'akun-program' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Admin GTK',
        desc: 'Pengelolaan data Akun Admin GTK',
        color: 'pink',
        deepColor: 'darken-4',
        akses: 'akun-admin-gtk.index',
        link: 'akun-gtk',
        to: { name: 'akun-gtk' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Admin Pusat GTK',
        desc: 'Pengelolaan data Akun Admin Pusat GTK',
        color: 'purple',
        deepColor: 'darken-4',
        akses: 'akun-admin-pusat-gtk.index',
        link: 'akun-pusat-gtk',
        to: { name: 'akun-pusat-gtk' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Operator LPD',
        desc: 'Pengelolaan data Operator LPD',
        color: 'blue',
        deepColor: 'darken-1',
        akses: 'akun-operator-lpd.index',
        link: 'akun-operator',
        to: { name: 'akun-operator' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Pengajar dan Pembimbing',
        desc: 'Pengelolaan data Pengajar dan Pembimbing',
        color: 'orange',
        deepColor: 'darken-1',
        akses: 'akun-pengajar.index',
        link: 'akun-pengajar',
        to: { name: 'akun-pengajar' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Pengajar BIMTEK',
        desc: 'Pengelolaan data Pengajar BIMTEK',
        color: 'yellow',
        deepColor: 'darken-2',
        akses: 'akun-pengajar-bimtek.index',
        link: 'akun-bimtek',
        to: { name: 'akun-bimtek' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Admin Kelas',
        desc: 'Pengelolaan data Admin Kelas',
        color: 'green',
        deepColor: 'darken-2',
        akses: 'akun-admin-kelas.index',
        link: 'akun-kelas',
        to: { name: 'akun-kelas' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Pengajar Tambahan',
        desc: 'Pengelolaan data Akun Pengajar Tambahan',
        color: 'red',
        deepColor: 'darken-2',
        // akses: 'akun-pengajar-tambahan.index',
        akses: false,
        link: 'akun-pengajar-tambahan',
        to: { name: 'akun-pengajar-tambahan' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelola Pembimbing',
        desc: 'Pengelolaan data Pembimbing',
        color: 'orange',
        deepColor: 'darken-3',
        // akses: 'akun-pembimbing-praktik.index',
        akses: false,
        link: 'akun-pembimbing',
        to: { name: 'akun-pembimbing' },
      },
    ],
  },
  {
    key: 'profil',
    program: 'Profil Akun',
    subheading: 'Profil Akun',
    submenu: false,
    icon: 'mdi-card-account-details',
    menu: [
      {
        icon: 'mdi-account-tie',
        title: 'Profil',
        desc: 'Profil',
        color: 'success',
        deepColor: 'darken-1',
        akses: 'pengajar-profil.index',
        link: 'profil-pengajar',
        to: { name: 'profil-pengajar' },
      },
      {
        icon: 'mdi-account-tie',
        title: 'Profil Pengajar BIMTEK',
        desc: 'Profil data Pengajar BIMTEK',
        color: 'pink',
        deepColor: 'darken-2',
        akses: false,
        link: 'profil-bimtek',
        to: { name: 'profil-bimtek' },
      },
      {
        icon: 'mdi-account-tie',
        title: 'Profil Admin Kelas',
        desc: 'Profil data Admin Kelas',
        color: 'blue',
        deepColor: 'darken-2',
        akses: 'admin-kelas-profil.index',
        link: 'profil-kelas',
        to: { name: 'profil-kelas' },
      },
      {
        icon: 'mdi-account-tie',
        title: 'Profil',
        desc: 'Profil',
        color: 'blue',
        deepColor: 'darken-2',
        akses: 'pembimbing-profil.index',
        link: 'profil-pembimbing',
        to: { name: 'profil-pembimbing' },
      },
    ],
  },
  {
    key: 'verval',
    program: 'Verval',
    subheading: 'Verval Ajuan',
    submenu: false,
    icon: 'mdi-file-check',
    menu: [
      {
        icon: 'mdi-card-bulleted',
        title: 'Verval LPD',
        desc: 'Evaluasi dan Verifikasi Dokumen Penting Lembaga LPD',
        color: 'success',
        deepColor: 'darken-1',
        akses: 'lpd-verval.index',
        link: 'verval-lembaga',
        to: { name: 'verval-lembaga' },
      },
      {
        icon: 'mdi-account-check',
        title: 'Verval Petugas Tambahan',
        desc: 'Evaluasi dan Verifikasi Dokumen Penting Pengajar Tambahan',
        color: 'red',
        deepColor: 'darken-1',
        akses: 'petugas-verval.index',
        link: 'verval-pengajar',
        to: { name: 'verval-pengajar' },
      },
      {
        icon: 'mdi-google-classroom',
        title: 'Verval Kelas Diklat Daring',
        desc: 'Evaluasi dan Verifikasi Kelas Diklat',
        color: 'red',
        deepColor: 'darken-1',
        akses: 'kelas-verval.index',
        link: 'verval-kelas',
        to: { name: 'verval-kelas' },
      },
      {
        icon: 'mdi-google-classroom',
        title: 'Verval Kelas Diklat Luring',
        desc: 'Evaluasi dan Verifikasi Kelas Diklat Luring',
        color: 'red',
        deepColor: 'darken-1',
        akses: 'kelas-luring-verval.index',
        link: 'verval-kelas-luring',
        to: { name: 'verval-kelas-luring' },
      },
      {
        icon: 'mdi-google-classroom',
        title: 'Verval Kelas Bimtek PPM & PPTM',
        desc: 'Evaluasi dan Verifikasi Kelas Bimtek PPM & PPTM',
        color: 'red',
        deepColor: 'darken-1',
        // akses: 'kelas-bimtek-verval.index',
        akses: false,
        link: 'verval-kelas-refreshment',
        to: { name: 'verval-kelas-refreshment' },
      },
      {
        icon: 'mdi-account-check',
        title: 'Verval Laporan Pelaksanaan Diklat Luring',
        desc: 'Evaluasi dan Verifikasi Laporan Pelaksanaan Diklat Luring',
        color: 'orange',
        deepColor: 'darken-1',
        akses: 'kelas-luring-laporan.index',
        link: 'verval-laporan-pelaksanaan',
        to: { name: 'verval-laporan-pelaksanaan' },
      },
      {
        icon: 'mdi-puzzle-edit',
        title: 'Verval Klaim Diklat Luring',
        desc: 'Evaluasi dan Verifikasi Ajuan Klaim Diklat',
        color: 'orange',
        deepColor: 'darken-1',
        akses: 'klaim-diklat',
        link: 'verval-klaim',
        to: { name: 'verval-klaim' },
      },
    ],
  },
  {
    key: 'diklat',
    program: 'Diklat',
    subheading: 'Diklat',
    submenu: false,
    icon: 'mdi-format-list-text',
    menu: [
      {
        icon: 'mdi-calendar-edit',
        title: 'Kelola Jadwal',
        desc: 'Kelola diklat kelas dan peserta diklat',
        color: 'red',
        deepColor: 'darken-1',
        akses: 'diklat-periode.index',
        link: 'kelola-jadwal',
        to: { name: 'kelola-jadwal' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Diklat Daring Kombinasi',
        desc: 'Kelola diklat kelas dan peserta diklat daring',
        color: 'success',
        deepColor: 'darken-1',
        akses: 'lpd-diklat.index',
        link: 'kelola-diklat',
        to: { name: 'kelola-diklat' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Diklat Luring Tersistem',
        desc: 'Kelola diklat kelas dan peserta diklat daring',
        color: 'success',
        deepColor: 'darken-1',
        akses: 'lpd-luring-diklat.index',
        link: 'kelola-diklat-luring',
        to: { name: 'kelola-diklat-luring' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Diklat BCMP',
        desc: 'Kelola diklat kelas dan peserta diklat daring',
        color: 'teal',
        deepColor: 'darken-1',
        akses: 'bcmp-diklat.index',
        link: 'kelola-diklat-bcmp',
        to: { name: 'kelola-diklat-bcmp' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Bimtek PPM dan PPTM',
        desc: 'Kelola diklat kelas dan peserta bimtek <i>PPM dan PPTM</i>',
        color: 'teal',
        deepColor: 'darken-1',
        akses: 'lpd-bimtek-diklat.index',
        link: 'kelola-diklat-refreshment',
        to: { name: 'kelola-diklat-refreshment' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Pengajar dan Pembimbing',
        desc: 'Daftar Pengajar dan Pembimbing',
        color: 'red',
        deepColor: 'darken-4',
        akses: 'petugas.index',
        link: 'petugas',
        to: { name: 'petugas' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Peserta Non Dapodik',
        desc: 'Daftar Peserta non dapodik',
        color: 'purple',
        deepColor: 'darken-5',
        akses: 'lpd-peserta-non-ptk.index',
        link: 'peserta',
        to: { name: 'peserta' },
      },
      {
        icon: 'mdi-desktop-mac',
        title: 'Kelas Daring',
        desc: 'Daftar Kelas diklat kelas dan peserta diklat daring',
        color: 'success',
        deepColor: 'darken-1',
        akses: 'petugas-kelas.index',
        link: 'kelas-diklat',
        to: { name: 'kelas-diklat' },
      },
      {
        icon: 'mdi-desktop-mac',
        title: 'Kelas Luring',
        desc: 'Daftar Kelas diklat kelas dan peserta diklat luring',
        color: 'success',
        deepColor: 'darken-1',
        akses: 'petugas-luring-kelas.index',
        link: 'kelas-diklat-luring',
        to: { name: 'kelas-diklat-luring' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelas Bimtek BCMP',
        desc: '',
        color: 'purple',
        deepColor: 'darken-5',
        akses: 'petugas-kelas.index',
        link: 'kelas-diklat-bcmp',
        to: { name: 'kelas-diklat-bcmp' },
      },
      {
        icon: 'mdi-account-cog',
        title: 'Kelas Bimtek PPM & PPTM',
        desc: '',
        color: 'purple',
        deepColor: 'darken-5',
        akses: true,
        link: 'kelas-diklat-bimtek',
        to: { name: 'kelas-diklat-bimtek' },
      },
    ],
  },
  {
    icon: 'mdi-webhook',
    title: 'ke Aplikasi SIMPKB',
    desc: '',
    color: 'secondary',
    deepColor: 'darken-2',
    dividerTop: true,
    sidebar: true,
    akses: true,
    link: 'app-sim-pkb',
    href: '#SIM_PKB_URL#',
  },
];
